<template>
	<div v-if="blogPostStyle === 'card' || blogPostStyle === 'list'" class="rn-card box-card-style-default"
		:class="{'card-list-view': blogPostStyle === 'list'}">
		<div class="inner">
			<div class="thumbnail">
				<router-link class="image" :to="`/product-detail/${blog.id}`">
					<img class="w-100" :src="blog.img" :alt="blog.title">
				</router-link>
			</div>
			<div class="content">
				<ul v-if="blogPostStyle === 'card'" class="rn-meta-list">
					<li>
						<router-link :to="''">
							{{ blog.author }}
						</router-link>
					</li>
					<li class="separator">/</li>
					<li>{{ blog.publishedAt }}</li>
				</ul>
				<h4 class="title">
					<router-link :to="`/blog-details/${blog.id}`">
						{{ blog.title }}
					</router-link>
				</h4>
				<ul v-if="blogPostStyle === 'list'" class="rn-meta-list">
					<li>
						<router-link :to="''">
							{{ blog.author }}
						</router-link>
					</li>
					<li class="separator">/</li>
					<li>{{ blog.publishedAt }}</li>
				</ul>
				<p v-if="blogPostStyle === 'list'" class="descriptiion">
					{{ blog.excerpt }}
				</p>
			</div>
		</div>
	</div>

	<div v-else-if="blogPostStyle == 2" class="rn-card box-card-style-default edge-card-list-view">
		<div class="inner">
			<div class="onlycontent">
				<ProductTable :table-data="productsIntro" :table-data-key="productsIntroKey"></ProductTable>
			</div>
		</div>
	</div>
</template>

<script>
	import ProductTable from '../../components/elements/table/ProductsIntroTable.vue'

	export default {
		name: 'BlogPost',
		components:{
			ProductTable
		},
		props: {
			blog: {},
			productsIntroKey: '',
			productsIntro: {},
			blogPostStyle: {
				type: String,
				default: 'card'
			}
		}
	}
</script>
